'use client';

import { createContext, JSX, PropsWithChildren, useContext, useState } from 'react';
import { useExternalAuthId } from 'workos/components';

export enum LoginErrorType {
    INVALID_CREDENTIALS = 'invalid-credentials',
    RATE_LIMIT_EXCEEDED = 'rate-limit-exceeded',
}

export type LoginFormContext = {
    loginErrorType?: LoginErrorType;
    setLoginErrorType: (errorType: LoginErrorType) => void;
    externalAuthId?: string;
};
const context = createContext<LoginFormContext>({
    setLoginErrorType: () => {},
});

export const LoginFormProvider = ({ children }: PropsWithChildren): JSX.Element => {
    const [loginErrorType, setLoginErrorType] = useState<LoginErrorType | undefined>();
    const externalAuthId = useExternalAuthId() ?? undefined;
    return (
        <context.Provider value={{ loginErrorType, setLoginErrorType, externalAuthId }}>{children}</context.Provider>
    );
};

export const useLoginForm = (): LoginFormContext => useContext(context);
